(function() {
    'use strict';

    angular
        .module('backApp')
        .controller('FrameConfigLookController', FrameConfigLookController);

    FrameConfigLookController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', '$state', 'MessageService'];

    function FrameConfigLookController ($timeout, $scope, $stateParams, $uibModalInstance, entity, $state, MessageService) {
        var vm = this;
        vm.cancel = cancel;
        vm.url = entity.url;
        vm.domain = entity.domain;

        //返回
        function cancel() {
            $uibModalInstance.close();
        }
    }
})();
